const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

/**
 * Register the service worker in production
 * @param {Object} [config] - Configuration object
 * @param {Function} [config.onUpdate] - Callback for when an update is found
 * @param {Function} [config.onSuccess] - Callback for successful registration
 */
export async function register(config) {
  if (
    process.env.NODE_ENV !== "production" ||
    !("serviceWorker" in navigator)
  ) {
    return;
  }

  const publicUrl = new URL(
    process.env.REACT_APP_BASE_URL || "",
    window.location.href
  );
  if (publicUrl.origin !== window.location.origin) {
    console.warn(
      "Service worker registration skipped due to cross-origin REACT_APP_BASE_URL."
    );
    return;
  }

  try {
    window.addEventListener("load", async () => {
      const swUrl = `${process.env.REACT_APP_BASE_URL}/service-worker.js`;

      if (isLocalhost) {
        await checkValidServiceWorker(swUrl, config);
      } else {
        await registerValidServiceWorker(swUrl, config);
      }
    });
  } catch (error) {
    console.error("Failed to initialize service worker registration:", error);
  }
}

/**
 * Register a valid service worker
 * @param {string} swUrl - Service worker script URL
 * @param {Object} [config] - Configuration object
 */
async function registerValidServiceWorker(swUrl, config) {
  try {
    const registration = await navigator.serviceWorker.register(swUrl);
    console.log("Service worker registered:", registration);

    registration.onupdatefound = () => {
      const installingWorker = registration.installing;
      if (!installingWorker) return;

      installingWorker.onstatechange = () => {
        if (installingWorker.state === "installed") {
          if (navigator.serviceWorker.controller) {
            console.log(
              "New service worker content available. Update pending."
            );
            if (config && config.onUpdate) {
              config.onUpdate(registration);
            }
          } else {
            console.log("Service worker installed for the first time.");
            if (config && config.onSuccess) {
              config.onSuccess(registration);
            }
          }
        }
      };
    };
  } catch (error) {
    console.error("Service worker registration failed:", error);
  }
}

/**
 * Check if the service worker file is valid (for localhost)
 * @param {string} swUrl - Service worker script URL
 * @param {Object} [config] - Configuration object
 */
async function checkValidServiceWorker(swUrl, config) {
  try {
    const response = await fetch(swUrl, {
      headers: { "Service-Worker": "script" },
    });

    const contentType = response.headers.get("content-type");
    if (
      response.status === 404 ||
      (contentType && !contentType.includes("javascript"))
    ) {
      const registration = await navigator.serviceWorker.ready;
      await registration.unregister();
      console.log("Invalid service worker found. Unregistered and reloading.");
      window.location.reload();
    } else {
      await registerValidServiceWorker(swUrl, config);
      const registration = await navigator.serviceWorker.ready;
      console.log("Service worker is active and serving cache-first.");
    }
  } catch (error) {
    console.warn("No internet connection. App is running in offline mode.");
  }
}

/**
 * Unregister the service worker
 */
export async function unregister() {
  if (!("serviceWorker" in navigator)) return;

  try {
    const registration = await navigator.serviceWorker.ready;
    await registration.unregister();
    console.log("Service worker unregistered.");
  } catch (error) {
    console.error("Service worker unregistration failed:", error);
  }
}
